<template>
  <div>
    <div class="box">
      <BInputText
        label-text="学员："
        v-model="NameID"
        placeholder="姓名/身份证号"
      />
      <BBtnSecondary
        :img-src="require('@/assets/filter.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers">
        <div class="search-functions">
          <BBtnDropDown
              v-if="data_status!=='03'"
              btn-txt="添加学员"
              :img-src="require('@/assets/new.png')"
              :dropdown-data="this.dropdownData"
              :clicked="onClickedDropDown" 
              style="margin: 5px;"/>
            <BBtnPrimary
              v-if="pageList.length > 0"
              :clicked="handleAllComplete"
              btn-txt="一键结业"
              style="margin: 5px;"/>
        </div>
        <div class="search-result-summary">
          <div class="summary">学员：{{ studentTotalNum }}人</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="pageList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:idPhotoUrl1="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img
               v-if="item.data.idPhotoUrl != null && item.data.idPhotoUrl != ''"
              :src="item.data.idPhotoUrl"
              style="height: 60px; width: 60px; border-radius: 50%"
            />
            <img
              v-else
              src="@/assets/head_photo.png"
              style="height: 60px; width: 60px; border-radius: 50%"
            />
          </div>
        </template>
        <template v-slot:learnRates="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div style="width:60%;margin-right:5px;">
              <BProgressStudy v-model="item.data.learnRate" style="width: 100px;" />
            </div>
            <div style="width:15%;margin-top:3px;">{{item.data.learnRate}}%</div>
          </div>
        </template>
        <template v-slot:completeStatus1="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div
              style="cursor: pointer"
              v-if="item.data.completeStatus === '已结业'"
              @click="cancelCompleteBtn(item.data)"
            >
              {{ item.data.completeStatus }}
            </div>
            <div v-else>{{ item.data.completeStatus }}</div>
          </div>
        </template>
        <template v-slot:actions="item">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <div class="btn-detail" @click="handleDetail(item)">详情</div>
            <div class="btn-reset" @click="handleReset(item.data.userId)">重置</div>
            <div class="btn-delete" @click="handleDelete(item)">删除</div>
            <div class="btn-detail" @click="handleComplete(item.data)">
              结业
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchList, deleteed, reset, studyComplete ,allStudyComplete,cancelStudyComplete } from "@/api/studentManagement";
import BInputText from "../../components2/BInputText";
import Table from "../../components2/Table";
import BBtnSecondary from "../../components2/BBtnSecondary";
import PopupContents from "../../views2/sample/PopupContents";
import BProgressStudy from "../../components2/BProgressStudy";
import BBtnDropDown from "../../components2/BBtnDropDown";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from "../../events/Hub";
import Vue from "vue";
export default {
   /* 父子组件传参 data中定义的参数不能与props中定义的参数名一致 */
  props: ["classId","status"],
  name: "ClassManagement",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
    BBtnDropDown,
    BProgressStudy,
    BBtnPrimary,
  },
  data: () => ({
    limitList: [
      {
        value: 10,
        text: "10条/页",
      },
      {
        value: 20,
        text: "20条/页",
      },
      {
        value: 30,
        text: "30条/页",
      },
    ],
    id: 0,
    pageNum: 1,
    limit: 10,
    pageCount: 10,
    totalCount: 0,
    searchParam: {},
    studentTotalNum: 0,
    timeout: 3000,
    snackbarColor: "",
    snackbarText: "",
    totalPages: 0,
    page: 1,
    dropdownData: [
      {name: "手动添加"},
      {name: "批量导入"},
    ],
    NameID: "",
    userName: "",
    idCard: "",
    data: {},
    selected: [],
    singleSelect: false,
    loading: false,
    snackbar: false,
    snackbarObj: {
      snackbar: false,
      timeout: -1,
      color: "",
      text: "",
    },
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center", width: '3%' },
      { text: "头像", value: "idPhotoUrl1", sortable: false, align: "center", width: '4%' },
      { text: "姓名", value: "userName", sortable: false, align: "center", width: '7%' },
      { text: "性别", value: "sex", sortable: false, align: "center", width: '4%' },
      { text: "年龄", value: "age", sortable: false, align: "center", width: '4%' },
      { text: "身份证号", value: "idCardNum", sortable: false, align: "center", width: '13%' },
      { text: "手机号码", value: "telNo", sortable: false, align: "center", width: '8%' },
      { text: "学习进度", value: "learnRates", sortable: false, align: "center", width: '12%' },
      { text: "签到总数", value: "signInTotalNum", sortable: false, align: "center", width: '7%' },
      { text: "结业状态", value: "completeStatus1", sortable: false, align: "center", width: '7%' },
      { text: "添加时间", value: "createTime", sortable: false, align: "center", width: '11%' },
      { text: "操作", value: "actions", sortable: false, align: "center" },
    ],
    pageList: [],
    deleteDialog: false,
    deleteDialogFlag: false,
    classNum: "",
    deleteId: "",
    data_classId: "",
    controlFlag: "",
    data_status:'',
    navi: [{ name: "class-management" }, { name: "student-management" }],
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     const params = {
  //       classId: vm.$route.params.classId,
  //       status: vm.$route.params.status,
  //     };
  //     console.log(params)
  //     if (
  //       params.classId !== null &&
  //       params.classId !== "" &&
  //       params.classId !== undefined && 
  //       params.status !== null &&
  //       params.status !== "" &&
  //       params.status !== undefined
  //     ) {
  //       // 把不为空的参数存入缓存
  //       vm.$store.commit("SET_STUDENT_MANAGEMENT_PARAMS", params);
  //     }
  //     // 查询条件赋值
  //     if (
  //       vm.$store.state.studentManagement_classId !== undefined &&
  //       vm.$store.state.studentManagement_classId !== null &&
  //       vm.$store.state.studentManagement_classId !== "" &&
  //       vm.$store.state.studentManagement_status !== undefined &&
  //       vm.$store.state.studentManagement_status !== null &&
  //       vm.$store.state.studentManagement_status !== ""
  //     ) {
  //       vm.classId = vm.$store.state.studentManagement_classId;
  //       vm.status = vm.$store.state.studentManagement_status;
  //     }
  //     vm.searchList();
  //   });
  // },
  // beforeMount() {
  //   this.$store.commit("SET_NAVI_DATA", this.navi);
  // },
  mounted() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
    console.log("********8989898989898999==",this.$store.state.public_classId);
    this.data_classId = this.$store.state.public_classId
    this.data_status = this.$store.state.public_status;
    this.searchList();
    this.$nextTick(
      function () {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
  methods: {
    // 重置
    async handleReset(userId){
      var param = {
        id: userId
      }
      const data = await reset(param)
      if(data.code === 0){
        this.data.bodyText = "该学员密码已重置为：123456";
        Hub.$emit("open-modal");
        Hub.$emit("set-modal-data", this.data.bodyText, "重置密码", PopupContents);
      }else{
        Vue.prototype.$valertbar.show(data.msg);
      }
        
    },
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
      } 
      this.searchList();
    },
    async searchList() {
      if (isNaN(this.NameID)) {
        this.userName = this.NameID;
        this.idCard = "";
      } else {
        this.idCard = this.NameID;
        this.userName = "";
      }
      var param = {
        page: this.page,
        limit: this.limit,
        classId: this.classId,
        userName: this.userName,
        idCard: this.idCard,
      };
      const data = await searchList(param);
      console.log("************=",data);
      if (data.data.searchList != null || data.data.searchList === "") {
        this.pageList = data.data.searchList;
        this.studentTotalNum = data.data.studentTotalNum;
      }
      this.totalCount = data.data.totalPage;
      this.totalPages = Math.ceil(this.totalCount / this.pageCount);
    },
    // 新增
    onClickedDropDown(name) {
      if("批量导入" === name) {
        this.$router.push({
          name: "student-add-import",
          params: {
            classId: this.data_classId,
          },
        });
      }
      if("手动添加" === name) {
        this.$router.push({
          name: "student-add",
          params: {
            isHas: 0,
            classId: this.data_classId,
          },
        });
      }
    },
    // 点击详情
    handleDetail(item) {
      this.$router.push({
        name: "student-detail",
        params: {
          id: item.data.userId,
          studentId: item.data.studentId,
          age: item.data.age,
          userName: item.data.userName,
          idCardNum: item.data.idCardNum,
          sex: item.data.sex,
          createTime: item.data.createTime,
          idPhotoUrl: item.data.idPhotoUrl,
          classId: this.data_classId,
        },
      });
    },
    // 点击删除
    handleDelete(item) {
      this.data.bodyText = "将同步删除该学员在学员端课程，确认删除该学员?";
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "提示", PopupContents);
      this.deleteId = item.data.studentId;
      this.controlFlag = 4
    },
    async delConfirmYes() {
      var param = {
        id: this.deleteId,
      };
      await deleteed(param);
      this.doSearch(true);
    },
    // 一键结业
    handleAllComplete() {
      this.data.bodyText = "是否将该班级未结业是的所有学员结业，结业后，学员端会收到结业证书，确认操作？";
      Hub.$emit("open-modal");
      Hub.$emit(
        "set-modal-data",
        this.data.bodyText,
        "结业提示",
        PopupContents
      );
      //this.classId = this.data_classId;
      this.controlFlag = 3;
    },
    // 结业
    handleComplete(item) {
      this.data.bodyText = "结业后，该学员端会收到结业证书，确认操作？";
      Hub.$emit("open-modal");
      Hub.$emit(
        "set-modal-data",
        this.data.bodyText,
        "结业提示",
        PopupContents
      );
      this.studentId = item.studentId;
      this.controlFlag = 1;
    },
    cancelCompleteBtn(item) {
      // 取消结业
      this.data.bodyText = '确认将该学员的结业状态改为"未结业"?';
      Hub.$emit("open-modal");
      Hub.$emit(
        "set-modal-data",
        this.data.bodyText,
        "结业状态更改",
        PopupContents
      );
      this.studentId = item.studentId;
      this.controlFlag = 2;
    },
    // 结业
    async studyComplete() {
      var param = {
        classId: this.classId,
        studentId: this.studentId,
      };
      const data = await studyComplete(param);
      if (data.data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.data.msg);
      }
      this.doSearch(true);
    },
    // 一键结业
    async allStudyComplete() {
      var param = {
        classId: this.classId,
      };
      const data = await allStudyComplete(param);
      if (data.data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.data.msg);
      } else {
        Vue.prototype.$valertbar.show(data.data.msg);
      }
      this.doSearch(true);
    },
    // 取消结业
    async cancelStudyComplete() {
      var param = {
        studentId: this.studentId,
        classId: this.classId,
      };
      const data = await cancelStudyComplete(param);
      Vue.prototype.$vsnackbar.show(data.data.msg);
      this.doSearch(true);
    },
     // 添加编辑页面返回值
    set(value) {
      if (value == 1) {
        // 结业
        if (this.controlFlag == 1) {
          this.studyComplete();
        } else if (this.controlFlag == 2) {
          // 取消结业
          this.cancelStudyComplete();
        } else if (this.controlFlag == 3) {
          // 一键结业
          this.allStudyComplete();
        } else if(this.controlFlag == 4){
          // 删除
          this.delConfirmYes();
        }

      } else if (value == 2) {
        this.doSearch(true)
      }
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*top: 0;*/
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  margin: 0 10px 0 20px;
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}

.btn-reset {
  margin: 0 10px 0 10px;
  color: #0171a3;
  cursor: pointer;
}

</style>
